<template>
  <div :key="periodsNumber + 'ball'" class="lottery-gruop clearfix">
    <!-- lotteryOpenAnimationMode: 0（号码随机变化 默认） 1（文字提示） -->
    <div v-if="!lotteryHall.lotteryOpenAnimationMode || LotteryLatelyLpVo.length">
      <!-- <template v-if="lotteryCode == 'CQSSC'">
        <cqssc :drawingNumber="LotteryLatelyLpVo" :types="types" :bigClass="bigClass"></cqssc>
      </template> -->
      <template v-if="bigClass == 'SSC' || bigClass == '11X5' || bigClass == 'LHC'|| bigClass == '3D'|| bigClass == 'PL3'|| bigClass == 'PCDD'|| bigClass == 'CQSSC'">
        <ssc :drawingNumber="LotteryLatelyLpVo" :types="types" :bigClass="bigClass" :lottery="lottery" />
      </template>
      <template v-if="bigClass == 'PK10'">
        <pk10 :drawingNumber="LotteryLatelyLpVo" :types="types" :bigClass="bigClass" :lottery="lottery" />
      </template>
      <template v-if="bigClass == 'K3'">
        <K3 :drawingNumber="LotteryLatelyLpVo" :types="types" :bigClass="bigClass" :lottery="lottery" />
      </template>
      <template v-if="bigClass == 'SSQ'">
        <ssq :drawingNumber="LotteryLatelyLpVo" :types="types" :bigClass="bigClass" :lottery="lottery" />
      </template>
      <template v-if="bigClass == 'DLT'">
        <dlt :drawingNumber="LotteryLatelyLpVo" :types="types" :bigClass="bigClass" :lottery="lottery" />
      </template>
      <template v-if="bigClass == 'ZHISHU'">
        <zhishu :drawingNumber="LotteryLatelyLpVo" :types="types" :bigClass="bigClass" :lottery="lottery" :LatelyLpVoDetail="LatelyLpVoDetail"/>
      </template>
      <template v-if="bigClass == 'LSC'">
        <lsc :drawingNumber="LotteryLatelyLpVo" :types="types" :bigClass="bigClass" :lottery="lottery" :LatelyLpVoDetail="LatelyLpVoDetail" />
      </template>
    </div>
    <div v-else-if="lottery" style="line-height: 84px;">正在开奖中...</div>
  </div>
</template>

<script>
import ssc from "./df-ssc";
import pk10 from "./df-pk10";
import K3 from "./df-k3";
import ssq from "./df-ssq";
import dlt from "./df-dlt";
import zhishu from "./zhishu";
import lsc from "./df-lsc.vue";
export default {
  name: "lottery-number",
  components: {
    ssc,
    pk10,
    K3,
    ssq,
    dlt,
    zhishu,
    lsc
  },
  data() {
    return {};
  },
  props: {
    lottery: {
      type: [Object],
      default: null
    },
    lotteryCode: {
      type: [String],
      default: null
    },
    types: {
      type: [String],
      default: null
    },
    bigClass: {
      type: [String],
      default: null,
    },
    LatelyLpVoDetail:{
      type:[Object],
      default:null
    }
  },
  computed: {
    // playwayConfig() {
    //   return this.$store.state.lottery.playwayConfig;
    // },
    lotteryTypeCode() {
      return this.$store.state.lottery.lotteryTypeCode;
    },
    // lotteryCode() {
    //   return this.$store.state.lottery.lotteryCode;
    // },
    periodsNumber() {
      return this.$store.state.lottery.periodsNumber;
    },
    LotteryLatelyLpVo() {
      if (this.lottery) {
        return this.lottery.drawingNumber
          ? this.lottery.drawingNumber.split(",")
          : [];
      } else {
        return [];
      }
    },
    // 开奖配置
    lotteryHall() {
      return this.$store.state.service.lotteryHall;
    },
  },
  methods: {
  },
  created() { }
};
</script>